import "./Tagline.css";

export function Tagline() {
  return (
    <p className="tagline crt-glow">RETRO TV. REAL ENTERTAINMENT.</p>
  );
}
